import React, { useState } from "react";
import { ScaleLoader } from "react-spinners";
import { Modal } from "react-bootstrap";
import { AxiosPost } from "../../../../../context/UserContext";
import { pushNotify } from "../../../../../services/NotifyService";
import { useEffect } from "react";
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import Button from '@inovua/reactdatagrid-community/packages/Button';
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
import DateFilter from '@inovua/reactdatagrid-community/DateFilter'
import moment from "moment";

function MessFoodLogs() {
    const [isLoading, setIsLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState({ show: false, id: null });
    const [foodLogs, setFoodLogs] = useState([]);
    const gridStyle = { height: 'calc(100vh - 16.5rem)', marginTop: 10 };
    const [gridRef, setGridRef] = useState(null)
    const initialFormData = {
        shoot_date: moment().format("YYYY-MM-DD"), activity_type: "shoot", hotel_name: '',
        qty1: '', rate1: '', total1: '', qty2: '', rate2: '', total2: '', qty3: '', rate3: '', total3: '', qty4: '', rate4: '', total4: '', remarks: ''
    }
    const [formData, setFormData] = useState([initialFormData])
    window.moment = moment
    const [customsl, setCustomSl] = useState(0)

    const filterValue = [
        { name: "num_row", operator: 'eq', type: 'number', value: null },
        { name: 'hotel_name', operator: 'startsWith', type: 'string', value: '' },
        { name: 'shoot_date', operator: 'after', type: 'date', value: '' },
        { name: 'activity_type', operator: 'eq', type: 'select', value: null },
        { name: 'remarks', operator: 'startsWith', type: 'string', value: '' },
    ];

    const shoot_options = [
        { id: "shoot", label: "shoot" },
        { id: "non-shoot", label: "non-shoot" }
    ]

    const columns = [
        { name: 'num_row', header: 'sl', type: 'number', editable: false },
        { name: 'hotel_name', header: 'Hotel Name' },
        {
            name: 'shoot_date', defaultFlex: 2, minWidth: 150, header: 'Shoot Date',
            dateFormat: 'YYYY-MM-DD',
            filterEditor: DateFilter,
        },
        {
            name: 'activity_type', defaultFlex: 2, minWidth: 150, header: 'Activity Type', filterEditor: SelectFilter,
            filterEditorProps: {
                placeholder: 'All',
                dataSource: shoot_options
            },
        },
        { name: 'qty1', defaultFlex: 2, minWidth: 150, header: 'BreakFast Quantity' },
        { name: 'total1', defaultFlex: 2, minWidth: 150, header: 'BreakFast Price' },
        { name: 'total1', defaultFlex: 2, minWidth: 150, header: 'BreakFast Total' },
        { name: 'qty2', defaultFlex: 2, minWidth: 150, header: 'Lunch Quantity' },
        { name: 'total2', defaultFlex: 2, minWidth: 150, header: 'Lunch Price' },
        { name: 'total2', defaultFlex: 2, minWidth: 150, header: 'Lunch Total' },
        { name: 'qty3', defaultFlex: 2, minWidth: 150, header: 'Snacks Quantity' },
        { name: 'total3', defaultFlex: 2, minWidth: 150, header: 'Snacks Price' },
        { name: 'total3', defaultFlex: 2, minWidth: 150, header: 'Snacks Total' },
        { name: 'qty4', defaultFlex: 2, minWidth: 150, header: 'Dinner Quantity' },
        { name: 'total4', defaultFlex: 2, minWidth: 150, header: 'Dinner Price' },
        { name: 'total4', defaultFlex: 2, minWidth: 150, header: 'Dinner Total' },
        { name: 'remarks', defaultFlex: 2, minWidth: 150, header: 'Remarks' },
        {
            name: 'sl', defaultFlex: 2, minWidth: 150, header: 'Actions', editable: false,
            render: ({ value }) =>
                <button className="btn btn-sharp" style={{ color: "red" }} onClick={() => showDeleteForm(value)}><i class="fas fa-trash-alt"></i></button>
        },
    ];

    const exportCSV = () => {
        const columns = gridRef.current.visibleColumns;

        const header = columns.map((c) => c.name).join(',');
        const rows = gridRef.current.data.map((data) => columns.map((c) => data[c.id]).join(','));

        const contents = [header].concat(rows).join('\n');
        const blob = new Blob([contents], { type: 'text/csv;charset=utf-8;' });

        downloadBlob(blob);
    };

    const downloadBlob = (blob, fileName = 'grid-data.csv') => {
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.position = 'absolute';
        link.style.visibility = 'hidden';

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    };

    useEffect(() => {
        fetchLogsData()
    }, [])

    const updateCustomSl = (logs, date) => {
        let temp = 0
        logs.map((log) => {
            if (log.shoot_date == date && log.num_row > temp) {
                console.log(log.num_row)
                temp = parseInt(log.num_row)

            }
        })
        setCustomSl(temp)
    }

    const fetchLogsData = async () => {
        setIsLoading(true);
        try {
            const data = await AxiosPost('fetch_messfood_logs.php')
            if (data.success) {
                setFoodLogs(data.logs)
                updateCustomSl(data.logs, moment().format("YYYY-MM-DD"))
            }
            else pushNotify("error", "Error", data.error)
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const showDeleteForm = (index) => {
        setDeleteModal({ show: true, id: index });
    }

    const deleteItem = async () => {
        setIsLoading(true);
        try {
            const data = await AxiosPost('delete_messfood_log.php', { sl: deleteModal.id })
            console.log(data);
            if (data.success) pushNotify('success', 'Success', 'Item Deleted Successfully');
            else pushNotify('error', 'Error', data.error);
            setDeleteModal({ show: false, id: null });
            await fetchLogsData();
            console.log(data);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const cancelDelete = () => {
        setDeleteModal({ show: false, id: null });
    }

    const onChangeHandler = (e, index) => {
        let old = [...formData]
        old[index] = { ...old[index], [e.target.name]: e.target.value }
        if (e.target.name == "qty1" || e.target.name == "qty2" || e.target.name == "qty3" || e.target.name == "qty4" ||
            e.target.name == "rate1" || e.target.name == "rate2" || e.target.name == "rate3" || e.target.name == "rate4" ||
            e.target.name == "total1" || e.target.name == "total2" || e.target.name == "total3" || e.target.name == "total4") {
            old[index] = {
                ...old[index],
                "total1": getNumber(old[index].qty1) * getNumber(old[index].rate1),
                "total2": getNumber(old[index].qty2) * getNumber(old[index].rate2),
                "total3": getNumber(old[index].qty3) * getNumber(old[index].rate3),
                "total4": getNumber(old[index].qty4) * getNumber(old[index].rate4)
            }
        }
        setFormData(old)
    }

    function getNumber(value) {
        const num = parseFloat(value);
        return isNaN(num) ? 0 : num;
    }

    const addMessFoodLogs = async (e) => {
        e.preventDefault()
        try {

            const data = await AxiosPost('add_messfood_log.php', formData)
            console.log(data);
            if (data.success) {
                setFormData([initialFormData])
                await fetchLogsData()
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const removeRow = (i) => {
        let old = []
        formData.map((data, index) => index == i ? null : old.push(data))
        setFormData(old)
    }

    const datechangehandler = (e) => {
        let old = [...formData]
        old.map((data, index) => {
            old[index].shoot_date = e.target.value
        })
        setFormData(old)
    }

    const onEditComplete = async (e) => {
        try {
            setIsLoading(true)
            let formData = { ...e.data, [e.columnId]: e.value }
            const data = await AxiosPost('update_messfood_logs.php', formData)
            if (data.success) {
                await fetchLogsData()
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }


    return (
        <div className="col-lg-12 col-md-12 col-sm-12">
            <div>
                {
                    isLoading ? <ScaleLoader cssOverride={{ "display": "flex", "justifyContent": "center", "alignItems": "center" }} /> :
                        <form className='custom-form-wrapper mb-2' onSubmit={(e) => addMessFoodLogs(e)}>
                            <div className="custom-form-inner">
                                <div className='custom-form-cell'>
                                    <div className='custom-form-label'>
                                        Shoot Date <span className="text-danger">*</span>
                                    </div>
                                    <div className='custom-form-input'>
                                        <input type="date" value={formData[0].shoot_date} name="shoot_date" onChange={(e) => { datechangehandler(e); updateCustomSl(foodLogs, e.target.value) }} required />
                                    </div>
                                </div>
                            </div>
                            {
                                formData.map((data, index) => (
                                    <div className='custom-form-inner'>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Sl
                                                <button className="btn btn-primary tp-btn sharp custom-add-button" onClick={(e) => { e.preventDefault(); setFormData([...formData, { ...initialFormData, shoot_date: formData[0].shoot_date }]) }} ><i className="fas fa-plus"></i></button>
                                                {index == 0 ? null : <button className="btn btn-primary tp-btn sharp custom-add-button" onClick={(e) => { e.preventDefault(); removeRow(index) }} ><i className="fas fa-minus"></i></button>}
                                            </div>
                                            <div className='custom-form-input'>
                                                <div className="form-control">{customsl + index + 1}</div>
                                            </div>
                                        </div>

                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Hotel Name <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].hotel_name} name="hotel_name" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Breakfast Quantity <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].qty1} name="qty1" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Breakfast Price <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].rate1} name="rate1" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Breakfast Total <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].total1} name="total1" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Lunch Quantity <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].qty2} name="qty2" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Lunch Price <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].rate2} name="rate2" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Lunch Total <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].total2} name="total2" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Snacks Quantity <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].qty3} name="qty3" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Snacks Price <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].rate3} name="rate3" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Snacks Total <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].total3} name="total3" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Dinner Quantity <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].qty4} name="qty4" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Dinner Price <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].rate4} name="rate4" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Dinner Total <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="number" value={formData[index].total4} name="total4" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Activity Type
                                            </div>
                                            <div className='custom-form-input'>
                                                <select value={formData[index].activity_type} name="activity_type" onChange={(e) => onChangeHandler(e, index)} >
                                                    <option value="shoot">Shoot</option>
                                                    <option value="non-shoot">Non Shoot</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Remarks
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].remarks} name="remarks" onChange={(e) => onChangeHandler(e, index)} />
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }

                            <Button className="mt-2 mb-2">
                                Add Food Log
                            </Button>
                        </form>
                }

            </div>

            <>
                <Button onClick={fetchLogsData}>
                    Sync Data
                </Button>
                <Button style={{ marginLeft: 10 }} onClick={exportCSV}>
                    Export CSV
                </Button>
                <ReactDataGrid
                    style={gridStyle}
                    columns={columns}
                    pagination="local"
                    dataSource={foodLogs}
                    defaultLimit={25}
                    defaultFilterValue={filterValue}
                    handle={setGridRef}
                    loading={isLoading}
                    editable={true}
                    onEditComplete={onEditComplete}
                />
            </>
            <Modal className="fade" show={deleteModal.show} centered>
                <Modal.Header>
                    <Modal.Title>Delete Log?</Modal.Title>
                    <button
                        onClick={cancelDelete}
                        className="btn-close"
                    >
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4>Are you sure you want to delete the Log?</h4>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        onClick={deleteItem}
                        className="btn btn-danger"
                    >
                        Delete
                    </button>
                    <button className="btn btn-primary" onClick={cancelDelete}>Cancel</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
export default MessFoodLogs;